import React from "react";
import {
  FaEnvelope,
  FaGithub,
  FaFacebook,
  FaLinkedin,
  FaYoutube,
} from "react-icons/fa";
import { SiSemanticweb } from "react-icons/si";

const FooterIcon = () => {
  return (
    <div className="flex  items-center gap-4 text-xl">
      <a href="https://github.com/noorjsdivs">
        <span className="w-10 h-10 rounded-full bg-[#fff3] flex justify-center items-center hover:bg-designColor duration-300 cursor-pointer hover:text-black">
          <FaGithub />
        </span>
      </a>
      <a href="https://www.youtube.com/@reactjsBD">
        <span className="w-10 h-10 rounded-full bg-[#fff3] flex justify-center items-center hover:bg-designColor duration-300 cursor-pointer hover:text-black">
          <FaYoutube />
        </span>
      </a>
      <a href="https://www.linkedin.com/in/noor-mohammad-ab2245193/">
        <span className="w-10 h-10 rounded-full bg-[#fff3] flex justify-center items-center hover:bg-designColor duration-300 cursor-pointer hover:text-black">
          <FaLinkedin />
        </span>
      </a>
      <a href="https://www.facebook.com/Noorlalu143/">
        <span className="w-10 h-10 rounded-full bg-[#fff3] flex justify-center items-center hover:bg-designColor duration-300 cursor-pointer hover:text-black">
          <FaFacebook />
        </span>
      </a>

      <a href="https://www.reactbd.com/">
        <span className="w-10 h-10 rounded-full bg-[#fff3] flex justify-center items-center hover:bg-designColor duration-300 cursor-pointer hover:text-black">
          <SiSemanticweb />
        </span>
      </a>
      <a href="mailto:noor.jsdivs@gmail.com">
        <span className="w-10 h-10 rounded-full bg-[#fff3] flex justify-center items-center hover:bg-designColor duration-300 cursor-pointer hover:text-black">
          <FaEnvelope />
        </span>
      </a>
    </div>
  );
};

export default FooterIcon;
